import { render, staticRenderFns } from "./CreateAudience.vue?vue&type=template&id=04399e59&"
import script from "./CreateAudience.vue?vue&type=script&lang=ts&"
export * from "./CreateAudience.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAudience.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports